module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-6.529eb43d.jpg";